import { gql } from 'graphql-request';

export const PRICING_ROOM_FRAGMENT = gql`
    fragment PricingRoomFragment on PricingRoom {
        id
        hotelId
        roomName
        rateType
        integrationId
        rateName
        board
        catalogueEligible
        numberOfRooms
    }
`;

export const PRICING_STRATEGY_FRAGMENT = gql`
    fragment PricingStrategyFragment on PricingStrategy {
        architectureId
        creationDate
        minimum {
            type
            competitorIds
            evaluate
            amount
            percentage
						threshold
						followsRoomAdjustments
        }
        maximum {
            type
            competitorIds
            evaluate
            amount
            percentage
						threshold
						followsRoomAdjustments
        }
        
    }
`;

export const PRICING_ARCHITECTURE_FRAGMENT = gql`
		${PRICING_ROOM_FRAGMENT}
		${PRICING_STRATEGY_FRAGMENT}
    fragment PricingArchitectureFragment on PricingArchitecture {
        id
        orderIndex
        anchor {
            ...PricingRoomFragment
        }
        competitorsMappingType
        derivatives {
						id
            pricingRoom {
                ...PricingRoomFragment
            }
            rule {
                type
                value
            }
        }
				hasStrategy
				strategy {
						...PricingStrategyFragment
        }
    }
`;

export const PRICING_SUBMISSION_FRAGMENT = gql`
	fragment PricingSubmissionFragment on PricingSubmission {
      id
      creationDate
      submissionDate
      finishDate
      type
      state
      profileName
      items {
					id
					recommendationStateId
					submissionId
          pricingArchitectureRoomId
					statDate
					basePrice
					applyPrice
			}
	}
`
